import httpClient from '../http-client';
import DashboardFromResponse from '../models/from-api-response/dashboard';

const getDashboard = async (): Promise<DashboardFromResponse> => {
  const { data } = await httpClient.get('/dashboard');
  return data;
};

export { getDashboard };
